import { FC } from 'react';

import { Box } from '@mui/material';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard';
import { UnauthorizedSaveProject } from 'components/UnauthorizedSaveProject/UnauthorizedSaveProject';

import { InstructionsDecorator } from '../InstructionsDecorator';

import styles from './EditModeComponent.module.scss';

export const EditModeComponent: FC = () => {
  const { isAuthenticated, isAuthConfiguring } = useAuthenticated();

  return (
    <Box className={styles.editSideBarWrapper}>
      {!(isAuthenticated || isAuthConfiguring) && <UnauthorizedSaveProject />}
      <AIAssistantAlertCard />
      <InstructionsDecorator />
    </Box>
  );
};
